import { endOfDay, format, startOfDay } from "date-fns";

export const DIVERGENCE_DATE_FORMAT = "yyyy-MM-dd";

export function toDivergenceDateParam(date: Date): string {
  return format(date, DIVERGENCE_DATE_FORMAT);
}

export function getDefaultDivergenceDateRange(maxDays: number) {
  const maxDaysInMilliseconds = 1000 * 60 * 60 * 24 * maxDays;
  const toDate = new Date(Date.now() + 1000 * 60 * 60 * 24);
  const fromDate = new Date(toDate.getTime() - maxDaysInMilliseconds);

  return {
    after: toDivergenceDateParam(startOfDay(fromDate)),
    before: toDivergenceDateParam(endOfDay(toDate)),
  };
}
